import { useEngineStartupQuery } from './engineStartup.queries';
import { EngineStartupFlight } from '../../../../types/api';

// STD-015: thin adapter — preserves the { flights, loading, error }
// return shape expected by HealthPanelTab while delegating fetch to TanStack Query.

interface UseEngineStartupResult {
  flights: EngineStartupFlight[];
  loading: boolean;
  error: string | null;
}

export const useEngineStartup = (droneSerial: string | null): UseEngineStartupResult => {
  const query = useEngineStartupQuery(droneSerial);
  return {
    flights: query.flights,
    loading: query.isLoading,
    error: query.error,
  };
};
